// extracted by css-extract-rspack-plugin
export default {"pointer":"index__pointer___Fl0iE"};